import type { ComponentProps, ReactNode, RefObject } from 'react';
import {
	Dialog,
	DialogTrigger,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogFooter,
	DialogClose,
} from '@worldcoo/ui/components/dialog';
import { Button } from '@worldcoo/ui/components/button';
import { Gradient } from '@worldcoo/ui/custom/gradient';
import { DivWithPrimaryColorVariable } from './div-with-primary-color-variable';
import { IsScrolledToBottom } from '../../-components/is-scrolled-to-bottom';

export function TermsCheckboxField(props: {
	field: {
		CheckboxField: React.ComponentType<ComponentProps<'button'> & { label?: ReactNode; acceptIndeterminate?: boolean }>;
	};
	labelText: string;
	linkText: string;
	dialogTitle: string;
	acceptButtonText: string;
	open: boolean;
	onOpenChange: (open: boolean) => void;
	labelRef: RefObject<HTMLDivElement | null>;
	dialogRef: RefObject<HTMLDivElement | null>;
	textRef: RefObject<HTMLTableElement | HTMLDivElement | null>;
	termsContent: ReactNode;
	onAccept: () => void;
	hideUnresetTailwind?: boolean;
}) {
	return (
		<props.field.CheckboxField
			className="gap-3"
			label={
				<div ref={props.labelRef} className="font-normal">
					{props.labelText}
					<Dialog open={props.open} onOpenChange={props.onOpenChange}>
						<DialogTrigger className="text-primary contents cursor-pointer">{props.linkText}</DialogTrigger>
						<DialogContent
							ref={props.dialogRef}
							aria-describedby={undefined}
							className="scrollbar flex max-h-dvh flex-col gap-6 overflow-y-auto sm:max-w-xl"
						>
							<DialogHeader>
								<DialogTitle className="capitalize">{props.dialogTitle}</DialogTitle>
							</DialogHeader>

							<DivWithPrimaryColorVariable className={props.hideUnresetTailwind ? undefined : 'unreset-tailwind'}>
								{props.termsContent}
							</DivWithPrimaryColorVariable>

							<DivWithPrimaryColorVariable className="sticky bottom-0 pt-12">
								<Gradient className="absolute -bottom-6 -z-10 h-[180px]" />
								<DialogFooter>
									<DialogClose asChild>
										<IsScrolledToBottom dialogRef={props.dialogRef}>
											{(scrolledToBottom) => (
												<Button
													type="button"
													size="xl"
													className="mx-auto"
													style={{ transition: 'all 0.15s ease-in-out' }}
													disabled={!scrolledToBottom}
													onClick={props.onAccept}
												>
													{props.acceptButtonText}
												</Button>
											)}
										</IsScrolledToBottom>
									</DialogClose>
								</DialogFooter>
							</DivWithPrimaryColorVariable>
						</DialogContent>
					</Dialog>
				</div>
			}
		/>
	);
}
